export default IconTentOff => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-tent-off" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M11 14l4 6h5m-2.863 -6.868l-5.137 -9.132l-1.44 2.559m-1.44 2.563l-6.12 10.878h6l4 -6" />
  <path d="M3 3l18 18" />
</svg>`;